import { Page } from "../components/styled";
import { useEffect,useState} from "react";
import { getProducts } from "../service/main/api";
import ProductSlider from "../components/ProductSlider";
import ProductContainer from "../components/productContainer";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../context/LoadingContext";
import BagSVG from "../assets/icons/bag.svg";
import MenuChainSVG from "../assets/icons/menu_chain.svg";
import MarketNewSVG from "../assets/icons/market_new.png";

const Home = () => {
    const [hunterPack,setHunterPack] = useState(null);
    const [products,setProducts] = useState([]);
    const { setIsLoading } = useLoading();
    const navigate = useNavigate();

    const getPacks = async () => {
        setIsLoading(true);
        const response = await getProducts({modelTypes:["CardPack","GroupedItems"]});
        if (!response?.success) {
            setIsLoading(false)
            return;
        }
        setHunterPack(response.data.find(product => product.item.name === "Hunter Pack"));
        setProducts(response.data.filter(product => product.price > 0));
        setIsLoading(false);
    }
    useEffect(() => {
        getPacks();
    }, []);

    return (
        <Page style={{paddingBottom:0}}>
            <HomeButtonContainer>
        <HomeButton
          onClick={() => navigate("/inventory")}
          src={BagSVG}
          alt="Home"
        />
        <HomeButtonText>Inventory</HomeButtonText>
      </HomeButtonContainer>
           {/* <ProductContainer product={hunterPack} />  */}
           <ProductSlider products={products} />
             <HomeButtonContainer style={{ right: "2vh", left: "auto" }}>
        <HomeButton
          onClick={() => navigate("/orders")}
          src={MenuChainSVG}
          alt="Orders"
        />
        <HomeButtonText>History</HomeButtonText>
      </HomeButtonContainer>
      <HomeButtonContainer style={{ right: "2vh", left: "auto", top: "28vh" }}>
        <HomeButton
          onClick={() => navigate("/market")}
          src={MarketNewSVG}
          alt="Store"
        />
        <HomeButtonText>Store</HomeButtonText>
      </HomeButtonContainer>
        </Page>
    );
}
const HomeButton = styled.img`
    width: 42px;
    height: 42px;
    cursor: pointer;
    border-radius: 4px;
    
`
const HomeButtonContainer = styled.div`
  position: absolute;
  top: 17vh;
  left: 2vw;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;
const HomeButtonText = styled.p`
  color: #fff;
  font-size: 9px;
  font-weight: 800;
  margin-top: 2px;
`;
export default Home;